import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./navbar.css";
import logo from "../../assets/Redite-logo.png";
import AOS from "aos";
import "aos/dist/aos.css";

function Navbar() {
  const navigate = useNavigate();
  const [openDropdown, setOpenDropdown] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const closeMobileMenu = () => {
    const navbar = document.getElementById("navbarNav");
    if (navbar?.classList.contains("show")) {
      navbar.classList.remove("show");
    }
  };

  // Mobile dropdown toggle using arrow
  const toggleDropdown = (menu) => {
    setOpenDropdown(openDropdown === menu ? null : menu);
  };

  // Mobile click → navigate
  const mobileNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
    closeMobileMenu();
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top">
      <div className="container d-flex justify-content-between align-items-center">

        {/* Logo */}
        <NavLink className="navbar-brand" to="/" onClick={closeMobileMenu}>
          <img src={logo} alt="Logo" />
          {/* <figcaption className="logo-wordings">Formerly Called Fazo Software</figcaption> */}
        </NavLink>

        {/* Mobile button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* NAV LINKS */}
        <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
          <ul className="navbar-nav">

            {/* HOME */}
            <li className="nav-item">
              <NavLink
                to="/"
                className="nav-link"
                onClick={() => mobileNavigate("/")}
              >
                Home
              </NavLink>
            </li>

            {/* ABOUT */}
            <li className="nav-item">
              <NavLink
                to="/aboutus"
                className="nav-link"
                onClick={() => mobileNavigate("/aboutus")}
              >
                About
              </NavLink>
            </li>

            {/* SERVICES */}
            <li className="nav-item dropdown">

              {/* MOBILE - CLICK TEXT → NAVIGATE */}
              <div
                className="dropdown-mobile-row"
              >
                <span
                  className="mobile-text"
                  onClick={() => mobileNavigate("/service")}
                >
                  Services
                </span>

                {/* Arrow – open/close dropdown */}
                <span
                  className="arrow"
                  onClick={() => toggleDropdown("services")}
                >
                  {openDropdown === "services" ? "▲" : "▼"}
                </span>
              </div>

              {/* DESKTOP LINK */}
              <NavLink
                to="/service"
                className="nav-link dropdown-toggle desktop-link"
              >
                Services
              </NavLink>

              {/* DROPDOWN MENU */}
              <ul className={`dropdown-menu ${openDropdown === "services" ? "show" : ""}`}>
                <li><NavLink className="dropdown-item" to="/webdevelopment" onClick={() => mobileNavigate("/webdevelopment")}>Web Development</NavLink></li>
                <li><NavLink className="dropdown-item" to="/software" onClick={() => mobileNavigate("/software")}>Software Development</NavLink></li>
                <li><NavLink className="dropdown-item" to="/digitalmarketing" onClick={() => mobileNavigate("/digitalmarketing")}>Digital Marketing</NavLink></li>
                <li><NavLink className="dropdown-item" to="/ecommerce" onClick={() => mobileNavigate("/ecommerce")}>E-Commerce Website</NavLink></li>
                <li><NavLink className="dropdown-item" to="/seo" onClick={() => mobileNavigate("/seo")}>SEO Services</NavLink></li>
                <li><NavLink className="dropdown-item" to="/logo" onClick={() => mobileNavigate("/logo")}>Logo Design</NavLink></li>
                <li><NavLink className="dropdown-item" to="/webmaintance" onClick={() => mobileNavigate("/webmaintance")}>Web Maintenance</NavLink></li>
                <li><NavLink className="dropdown-item" to="/testing" onClick={() => mobileNavigate("/testing")}>Software Testing</NavLink></li>
              </ul>
            </li>

            {/* CONTACT */}
            <li className="nav-item dropdown">

              <div className="dropdown-mobile-row">
                <span
                  className="mobile-text"
                  onClick={() => mobileNavigate("/contactus")}
                >
                  Contact
                </span>

                <span
                  className="arrow"
                  onClick={() => toggleDropdown("contact")}
                >
                  {openDropdown === "contact" ? "▲" : "▼"}
                </span>
              </div>

              <NavLink
                to="/contactus"
                className="nav-link dropdown-toggle desktop-link"
              >
                Contact
              </NavLink>

              <ul className={`dropdown-menu ${openDropdown === "contact" ? "show" : ""}`}>
                <li><NavLink className="dropdown-item" to="/faq" onClick={() => mobileNavigate("/faq")}>FAQ</NavLink></li>
              </ul>

            </li>

          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
